import styled from 'styled-components';

const matchResultColors: { [key: string]: string } = {
  D: 'var(--v3-yellow-7)',
  W: 'var(--v3-cyan-base)',
  L: 'var(--v3-red-base)'
};

export const StatisticsBanner = styled.div<{
  bgImageSrc?: string;
  fullHeight?: boolean;
  $loading?: boolean;
}>`
  ${props =>
    !props.$loading &&
    `background: url(${props.bgImageSrc}) rgba(0, 0, 0, 0.5) no-repeat center center;`}
  background-blend-mode: multiply;
  background-size: cover;
  height: 140px;
  margin: 8px 8px;
  border-radius: 4px;
  color: var(--v3-black-0);
  padding: 12px;
`;
export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: var(--v3-black-15);
`;
export const GameWrapper = styled.div<{
  fullHeight?: boolean;
}>`
  color: var(--v3-black-0);
  display: flex;
  justify-content: space-between;
  margin-top: ${props => (props.fullHeight ? '2px' : '12px')};
  align-items: center;
`;
export const Result = styled.span<{ resultKey: string }>`
  color: ${props => matchResultColors[props.resultKey]};
  background-color: var(--v3-black-100);
  border-radius: 2px;
  width: 16px;
  height: 16px;
  text-align: center;
  font-size: 11px;
  margin: 1px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const GameInfo = styled.p`
  font-size: 11px;
  color: var(--v3-white);
  padding-left: 13px;
  margin-bottom: 5px;
`;
